/* 🤖 this file was generated by svg-to-ts */
export const mgcIconMinimizeCuteRe: {
  name: 'minimize-cute-re';
  data: string;
} = {
  name: 'minimize-cute-re',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M4.673 11.063C4.31 11.175 4 11.606 4 12c0 .405.309.826.69.939.18.054 1.065.061 7.31.061s7.13-.007 7.31-.061c.378-.112.69-.537.69-.939s-.312-.827-.69-.939c-.301-.09-14.346-.087-14.637.002"/></svg>`
};
